import { render, staticRenderFns } from "./AD265UnicoreIndex.vue?vue&type=template&id=32b5cb16&scoped=true"
import script from "./AD265UnicoreIndex.vue?vue&type=script&lang=js"
export * from "./AD265UnicoreIndex.vue?vue&type=script&lang=js"
import style0 from "./AD265UnicoreIndex.vue?vue&type=style&index=0&id=32b5cb16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b5cb16",
  null
  
)

export default component.exports